/**
 * Estructura de routes de primer nivel
 *
 *   Solo deberíamos registrar el primer prefijo de la ruta
 * el resto se encarga otro.
 *
 * Si tenemos el modulo producción solo registramos
 *
 *   /produccion -> ModuloProducción
 *
 * Ese componente sabrá si hay más rutas o no, esto además nos permitirá dos cosas
 *
 *   - Mejorar la seguridad con los Permisos (no solo no mostramos rutas sino que no las cargamos)
 *   - Usar Lazy y Suspend para mejorar la performance
 *
 * OBS: El orden es importante en el matching
 *
 *    - path/
 *    - path/subpath    <- Nunca se va a ejecutar
 */

/**
 * La estructura debería ser de esta forma
 */
import HomeRoutes from './home'
import UserRoutes from './user'
import JobRoutes from './job/'
import TaskRoutes from './task/'
import QARoutes from './qa/'

import financeRoutes from './finance/routes'

import {
  LAYOUT_VENDOR_HOME,
  LAYOUT_VENDOR_USER_ROOT,
  LAYOUT_VENDOR_JOB_ROOT,
  LAYOUT_VENDOR_TASK_ROOT,
  LAYOUT_VENDOR_QA_ROOT
} from './navigation'

const routes = [
  {
    path: '/secure/index',
    component: HomeRoutes,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  },
  {
    path: LAYOUT_VENDOR_HOME,
    component: HomeRoutes,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  },
  {
    path: LAYOUT_VENDOR_JOB_ROOT,
    component: JobRoutes,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  },
  {
    path: LAYOUT_VENDOR_TASK_ROOT,
    component: TaskRoutes,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  },
  {
    path: LAYOUT_VENDOR_QA_ROOT,
    component: QARoutes,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  },
  {
    path: LAYOUT_VENDOR_USER_ROOT,
    component: UserRoutes,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  },
  ...financeRoutes
]

export default routes
